import type { Site } from '../Site';

export const YachtingMonthly: Site = {
  id: 'yachtingmonthly',
  logo: 'yachtingmonthly.png',
  label: 'Yachting Monthly',
  analyticsName: 'yachtingmonthly',
  hostname: 'yachtingmonthly.com',
  platform: 'ti',
  selector: '#content a',
};
